import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { IconButton } from '@repo/ui/components/Buttons';
import SearchFilledIcon from '@repo/ui/components/Icon/SearchFilledIcon';
import { themeStyle } from '@repo/ui/theming';

import { Backdrop } from 'components/HeadMenu/HeaderPopover/styles';
import HeaderSearchComponent from 'components/HeadMenu/HeaderSeach/HeaderSearchComponent';
import { WrapperContent } from 'components/HeadMenu/HeaderSeach/styles';
import { HeaderSearchProps } from 'components/HeadMenu/HeaderSeach/types';

import useHeaderFunctions from '../Header/useHeaderFunctions';
import HeaderPopover from '../HeaderPopover/HeaderPopover';

const iconTheme = {
  activeColor: themeStyle.varBackgroundAlt,
  activeDefaultColor: themeStyle.varInkMain,
};

const HeaderSearch: React.FC<HeaderSearchProps> = ({
  trendingSearch,
  dataTestId,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { searchProps } = useHeaderFunctions();

  return (
    <>
      <Backdrop visible={isOpen} onClick={() => setIsOpen(false)} />
      <IconButton
        ariaLabel="Search"
        dataTestId={dataTestId}
        height="16px"
        icon={SearchFilledIcon}
        name="toggleHeaderSearchButton"
        theme={iconTheme}
        tooltipText="Search"
        onClick={() => setIsOpen((o) => !o)}
      />
      <HeaderPopover visible={isOpen}>
        <WrapperContent>
          <HeaderSearchComponent
            isOpen={isOpen}
            searchProps={searchProps}
            trendingSearch={trendingSearch}
            onClose={() => setIsOpen(false)}
          />
        </WrapperContent>
      </HeaderPopover>
    </>
  );
};

export default withEventScope(HeaderSearch, { module: 'headerSearch' });
